(function () {
    'use strict';
    angular.module('Services')
        .factory('AdminPermissionService', AdminPermissionService);
    AdminPermissionService.$inject = ['Request'];

    function AdminPermissionService(Request) {

        return {
            Actionlog: {
                getTeamActionsList: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.adminPermission.actionlog,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    });
                }
            },
            AdminCurrentUser: {
                getAdminCurrentUserList: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.adminPermission.adminCurrentUser,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    })
                },
                getAdminUserDetails: function (callback, errCallback, id) {
                    const data = { id: id }
                    Request.get({
                        url: ApiURLs.adminPermission.adminCurrentUser,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    })
                },
                updateUserPermission: function (data, callback, errCallback, id) {
                    Request.post({
                        url: ApiURLs.adminPermission.adminUserUpdateModuleAccess.replace(':id', id),
                        method: 'PUT',
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data)
                },
                createAdminUserAccount: function (callback, errCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.adminPermission.createNewUserAdmin,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data)
                },
                createAdminUserPermission: function (callback, errCallback, data) {
                    Request.post({
                        url: ApiURLs.adminPermission.createAdminUserPermission,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data)
                },
                deleteAdminUserAccount: function (callback, errCallback, id) {
                    Request.delete({
                        url: ApiURLs.adminPermission.deleteAdminAccount.replace(':id', id),
                        successCallback: callback,
                        errorCallback: errCallback
                    })
                },
                disabledAdminAccount: function (callback, errCallback, payload) {
                    Request.post({
                        method: 'PATCH',
                        url: ApiURLs.adminPermission.disableUserAccount.replace(':id', payload.id).replace(':status', payload.status),
                        successCallback: callback,
                        errorCallback: errCallback
                    })
                },
                updateDetails: function (id, callback, errCallback, data) {
                    Request.post({
                        url: ApiURLs.adminPermission.updateUserAdminDetails.replace(':id', id),
                        method: 'PUT',
                        successCallback: callback,
                        errorCallback: errCallback
                    }, data)
                },
                generatePayload: function (data) {

                    const {
                        accessCompany,
                        areaIds,
                        employeeId,
                        permissionGroupId,
                        officeId,
                        companyId,
                        email,
                        firstName,
                        lastName,
                        phone1,
                        permissionAccess,
                        dashboardAccess
                    } = data;

                    let permissionId = permissionGroupId ? permissionGroupId.toString() : '';
                    const payload = {
                        areaIds: areaIds,
                        companies: accessCompany,
                        employeeId: data.user.employeeId,
                        moduleIds: [],
                        roleCodes: [permissionId],
                        user: {
                            active: true,
                            companyId,
                            email: data.user.email,
                            firstName: data.user.firstName,
                            lastName: data.user.lastName,
                            officeId,
                            password: '123456',
                            permissionGroupId,
                            phone1: data.user.phone1,
                            phone2: data.user.phone1,
                        }
                    };
                    angular.forEach(permissionAccess, function (item) {
                        if (item.active) {
                            payload.moduleIds.push(item.id)
                        }

                    });

                    angular.forEach(dashboardAccess,function (item) {
                        payload.moduleIds.push( {id:item.id,active:item.active})
                    });

                    return payload;
                }
            },
            AdminPermissionModule: {
                getPermissionModule: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.adminPermission.adminModuleAccess,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    })
                }
            },
            dashboardPermissionModule: {
                getPermissionModule: function (callback, errCallback, data) {
                    Request.get({
                        url: ApiURLs.adminPermission.adminModuleAccess,
                        successCallback: callback,
                        errorCallback: errCallback,
                        data: data
                    })
                }
            },
            areaAndRoute: {
                addArea: function (callback, errCallback, payload) {
                    Request.post({
                        url: ApiURLs.areaAndRoutePermission.create,
                        successCallback: callback,
                        errorCallback: errCallback
                    }, payload)
                }
            }
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/AdminPermissionService.js